module.exports = __webpack_public_path__ + "static/media/travel20.d42ad1d4.jpg";